import {closePopup} from "./odsPopupManager"

class Popup {
  public readonly id: string;
  private _isActive: boolean;
  private readonly _canClose: boolean;
  private readonly _size: PopupSize;
  private readonly _position: PopupPosition;
  private readonly _overflow: boolean;
  private readonly _specifiClass: string;
  private readonly _component: any;
  private readonly _componentProps: any;

  constructor(props: {
    id: string;
    canClose: boolean;
    size?: PopupSize;
    position?: PopupPosition;
    overflow?: boolean;
    specificClass?: string;
    component: any;
    componentProps: any;
  }) {
    this.id = props.id;
    this._isActive = false;
    this._canClose = typeof props.canClose == "boolean" ? props.canClose : true;
    this._size = props.size ?? PopupSize.Medium;
    this._position = props.position ?? PopupPosition.Center;
    this._overflow = props.overflow ?? false;
    this._specifiClass = props.specificClass ?? ''
    this._component = props.component;
    this._componentProps = props.componentProps;
  }

  get isActive() {
    return this._isActive
  }

  get canClose() {
    return this._canClose
  }

  get size() {
    return this._size
  }

  get position() {
    return this._position
  }

  get overflow() {
    return this._overflow
  }

  get specificClass() {
    return this._specifiClass
  }

  get component() {
    return this._component
  }

  get componentProps() {
    return this._componentProps
  }

  setActive(value) {
    this._isActive = value
  }

  close() {
    this.setActive(false)
    closePopup(this.id)
  }

}


export {Popup}

export enum PopupPosition {
  Center = 'center',
  Left = 'left',
  Right = 'right',
}

export enum PopupSize {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
  XL = 'xl',
  XXL = '2xl',
  Full = 'full'
}

export type PopupOptions = {
  id: string;
  canClose?: boolean;
  size?: PopupSize,
  position?: PopupPosition,
  overflow?: boolean,
  specificClass?: string,
  component?: any,
  componentProps?: any
}